export enum ValidationMode {
  CountlineValidation = "countlineValidation",
  NearMissValidation = "nearMissValidation",
}
